import React from 'react';
import { bool } from 'prop-types';

import Classes from './Skeleton.scss';

import SkeletonBase from './SkeletonBase';

const TextSkeleton = ({ withAnimation }) => (
  <SkeletonBase as="span" className={Classes.ButtonSkeleton} withAnimation={withAnimation} />
);

TextSkeleton.propTypes = {
  withAnimation: bool,
};

export default TextSkeleton;
